import { Chip, SelectButton, ToggleButton } from 'primereact';
import React, {useState} from "react";

export function Banco() {
  const [value, setValue] = React.useState(null);
  const items = [
    { name: "Banco", value: 1 },
    { name: "Tipo Pago", value: 2 },
    { name: "Caja Chica", value: 3 },
  ];

  function handleChange(value) {
    setValue(value);
    if (value === 1) {
      $("#divTipoPagosDetalle").addClass("hidden");
      $("#divCajaChicaDetalle").addClass("hidden");
      $("#divBancoDetalle").toggleClass("hidden");
    } else if (value === 2) {
      $("#divBancoDetalle").addClass("hidden");
      $("#divCajaChicaDetalle").addClass("hidden");
      $("#divTipoPagosDetalle").toggleClass("hidden");
    } else if (value === 3) {
      $("#divTipoPagosDetalle").addClass("hidden");
      $("#divBancoDetalle").addClass("hidden");
      $("#divCajaChicaDetalle").toggleClass("hidden");
    } else {
      $("#divTipoPagosDetalle").addClass("hidden");
      $("#divBancoDetalle").addClass("hidden");
      $("#divCajaChicaDetalle").addClass("hidden");
    }
  }

  return (
    <React.Fragment>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <SelectButton
          value={value}
          onChange={(e) => handleChange(e.value)}
          optionLabel="name"
          options={items}
        />
      </div>
    </React.Fragment>
  );
}